import React, { useEffect, useState } from 'react'

import clsx from 'clsx'

import useScrollTrigger from 'hooks/useScrollTrigger'

/** @type {import("./types").default} */
const StyleOnScroll = ({
  className,
  children,
  onScrollClassName,
  containerRef,
  target,
  type = 'addStyle',
  scrollThreshold = 15,
}) => {
  const [hasTarget, setHasTarget] = useState(false)
  const triggerOptions = {
    disableHysteresis: true,
    threshold: scrollThreshold,
  }

  useEffect(() => {
    setHasTarget(target !== undefined)
  }, [target])

  const triggerScroll = useScrollTrigger({
    ...triggerOptions,
    target: hasTarget ? target.current : undefined,
  })

  const style = {
    addStyle: (
      <div
        className={clsx(className, {
          [onScrollClassName]: triggerScroll,
        })}
        ref={containerRef}
      >
        {children}
      </div>
    ),
  }

  return style[type]
}

export default StyleOnScroll
